import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import ProfileProvider from './context/ProfileProvider';
import LaunchDarklyProvider from './context/LaunchDarklyProvider';
import ApiProvider from './context/ApiProvider';
import { TChannel, TSource } from './context/ProfileProvider/types';

import { Liferay } from './components/global/Liferay';

import Recommendation from './containers/Recommendation';
import {
  CHANNEL_DEFAULT,
  MOCK_ACTIVE,
  PLACE_DEFAULT,
  SOURCE_DEFAULT,
  SMILES_BASE_URL,
} from './config';

type TParams = {
  channel: TChannel;
  place: string;
  lazy: boolean;
  smilesBaseUrl: string;
  source: TSource;
};

const App = function ({
  channel = CHANNEL_DEFAULT,
  place = PLACE_DEFAULT,
  source = SOURCE_DEFAULT,
  lazy,
  smilesBaseUrl = SMILES_BASE_URL,
}: TParams) {
  const [loadRecommendation, setLoadRecommendation] = useState(!lazy);

  const handleLoadRecommendation = () => {
    setLoadRecommendation(true);
  };

  useEffect(() => {
    if (lazy) {
      window.addEventListener(
        `smls-recsys-load-${channel}-${place}`,
        handleLoadRecommendation,

        false,
      );
    }

    return () => {
      window.removeEventListener(
        `smls-recsys-load-${channel}-${place}`,
        handleLoadRecommendation,
      );
    };
  }, [channel, lazy, place]);

  if (!loadRecommendation) {
    return null;
  }

  return (
    <Liferay active={MOCK_ACTIVE}>
      <div id={`recsys_templates_place_${place}`}>
        <LaunchDarklyProvider>
          <ApiProvider>
            <ProfileProvider
              place={place}
              source={source}
              channel={channel}
              smilesBaseUrl={smilesBaseUrl}
            >
              <Recommendation />
            </ProfileProvider>
          </ApiProvider>
        </LaunchDarklyProvider>
      </div>
    </Liferay>
  );
};

export default App;

/* Configure WebComponent to load application on Liferay 7.4 */
export class WebComponent extends HTMLElement {
  connectedCallback() {
    const channel = this.getAttribute('channel') as TChannel;
    const place = this.getAttribute('place');
    const lazy = this.getAttribute('lazy');
    const smilesBaseUrl = this.getAttribute('smilesBaseUrl') || '';
    if (channel && place) {
      ReactDOM.render(
        <App
          channel={channel}
          place={place}
          source={SOURCE_DEFAULT}
          lazy={lazy === 'true'}
          smilesBaseUrl={smilesBaseUrl}
        />,
        this,
      );
    } else {
      console.error('Invalid recsys-templates configuration.');
    }
  }
}

const ELEMENT_ID = 'smiles-react-recsys-templates';

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
